module.exports = {"210381001":"海州街道","210381002":"兴海街道","210381003":"响堂街道","210381004":"东四街道","210381005":"验军街道","210381006":"温泉街道","210381101":"孤山镇","210381102":"岔沟镇","210381103":"接文镇","210381104":"析木镇","210381105":"马风镇","210381107":"牌楼镇","210381108":"八里镇","210381109":"毛祁镇","210381110":"英落镇","210381111":"感王镇","210381112":"西柳镇","210381113":"中小镇","210381114":"王石镇","210381115":"南台镇","210381118":"腾鳌镇","210381121":"耿庄镇","210381123":"牛庄镇","210381124":"西四镇","210381125":"望台镇","210381126":"温香镇","210381127":"高坨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210381.json
// module id = 483
// module chunks = 0